export const USER_DATA = 'userData';
export const SELECTED_CASE_NUMBER = 'selectedCaseNumber';
export const SELECTED_CASE_INFO = 'selectedCaseInfo';
export const DIRECT_DEPOSIT_DATA = 'directDepositData';
export const MORE_SELECTED_CASE = 'moreSelectedCase';
export const USER_OBJECT = 'userObject';
export const REQ_APPOINTMENT_DATA = 'reqAppointmentData';
export const REQ_APPOINTMENT_OPTIONS_DATA = 'reqAppointmentOptionsData';
export const MRA_MRC_FLAG = 'mraMrcFlag';
export const DEFFERAL_DATA = 'defferalData';
export const SUPPORT_ORDER_DATA = 'supportOrderData';
export const DEMOGRAPHICS_DATA = 'demogrpahicsData';
export const CHANGE_PASSWORD_DATA = 'changePasswordData';
export const FAQ_TOPIC = 'faqTopic';
export const SUPPORT_ORDER_DETAILS_DATA = 'supportOrderDetailsData';
export const USER_REGISTRATION_DETAILS = 'userRegistartionDetails';
export const RESET_PASSWORD_DATA = 'resetPasswordData';
export const TRANSACTION_ID = 'TransactionID';
export const STORED_NOTIFICATIONS = 'storedNotifications';
